(function () {
  function initStickyATC() {
    var bar = document.getElementById('sticky-atc-bar');
    var originalBtn = document.querySelector('[name="add"]');
    var variantContainer = document.getElementById('sticky-variant-options');
    var priceEl = document.getElementById('sticky-atc-price');

    if (!bar || !originalBtn) return;

    function formatPrice(cents) {
      return (cents / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency: window.__stickyAtcCurrency || 'EUR'
      });
    }

    function updateStickyPrice(optionValue) {
      if (!window.__stickyAtcVariants || !priceEl) return;

      var variant = window.__stickyAtcVariants.find(function (v) {
        return v.options && v.options.indexOf(optionValue) !== -1;
      });

      if (variant) {
        priceEl.textContent = formatPrice(variant.price);
      }
    }

    // Eerste prijs laden
    if (
      window.__stickyAtcVariants &&
      window.__stickyAtcVariants.length &&
      priceEl
    ) {
      priceEl.textContent = formatPrice(
        window.__stickyAtcVariants[0].price
      );
    }

    // Kloon variant knoppen naar sticky balk
    if (variantContainer) {
      var originalVariantInputs =
        document.querySelectorAll('.product-form__input');

      originalVariantInputs.forEach(function (inputGroup) {
        var clone = inputGroup.cloneNode(true);

        clone.querySelectorAll('[id]').forEach(function (el) {
          el.id = 'sticky-' + el.id;
        });

        clone.querySelectorAll('[for]').forEach(function (el) {
          el.setAttribute(
            'for',
            'sticky-' + el.getAttribute('for')
          );
        });

        variantContainer.appendChild(clone);
      });

      // Sticky → origineel
      variantContainer.addEventListener('click', function (e) {
        var label = e.target.closest('label');
        if (!label) return;

        var forId = label.getAttribute('for');
        if (!forId) return;

        var originalId = forId.replace('sticky-', '');
        var originalInput = document.getElementById(originalId);

        if (originalInput) {
          originalInput.click();

          updateStickyPrice(originalInput.value);
        }
      });

      // Origineel → sticky
      document.addEventListener('change', function (e) {
        if (
          e.target.closest('.product-form__input') &&
          !e.target.closest('#sticky-atc-bar')
        ) {
          var stickyInput = variantContainer.querySelector(
            'input[name="' +
              e.target.name +
              '"][value="' +
              e.target.value +
              '"]'
          );

          if (stickyInput) {
            stickyInput.checked = true;
          }

          updateStickyPrice(e.target.value);
        }
      });
    }

    var lastScrollY = window.scrollY;

// Zoek de onderkant van de Specificaties accordion
function getSpecificatiesBottom() {
  var headings = document.querySelectorAll('.accordion__title, summary, h2, h3');
  for (var i = 0; i < headings.length; i++) {
    if (headings[i].textContent.trim().toLowerCase().includes('specificaties')) {
      var details = headings[i].closest('details') || headings[i].closest('.accordion');
      if (details) return details.getBoundingClientRect().bottom;
    }
  }
  return null;
}

window.addEventListener('scroll', function () {
  var rect = originalBtn.getBoundingClientRect();
  var scrollingDown = window.scrollY > lastScrollY;
  var specsBottom = getSpecificatiesBottom();

  lastScrollY = window.scrollY;

  var specsPassed = specsBottom === null || specsBottom < 0;

  if (rect.bottom < 0 && scrollingDown && specsPassed) {
    bar.style.transform = 'translateY(0)';
  } else if (rect.top > 0 || !scrollingDown || !specsPassed) {
    bar.style.transform = 'translateY(100%)';
  }
});
   // Sticky knop
    document
      .getElementById('sticky-atc-btn')
      .addEventListener('click', function () {

        // ✅ Quantity meekopieren
        var originalQty = document.querySelector('form[action="/cart/add"] [name="quantity"]');
        if (originalQty) {
          originalQty.value = originalQty.value; // waarde blijft zoals ingesteld in hoofdformulier
        }

        var stickyNote =
          document.getElementById('sticky-cart-note');

        var originalNote = document.querySelector(
          '[name="properties[Kleurkeuze]"]'
        );

        if (stickyNote && originalNote) {
          originalNote.value = stickyNote.value;
        }

        originalBtn.click();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initStickyATC
    );
  } else {
    initStickyATC();
  }
})();




